/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { createOrUpdateTagModelSchema } from "../createOrUpdateTagModelSchema.ts";
import { int64CreatedOrUpdatedEntityModelSchema } from "../int64CreatedOrUpdatedEntityModelSchema.ts";
import { z } from "zod";

/**
 * @description Идентификатор созданного жанра
 */
export const postApiTags200Schema = z.lazy(() => int64CreatedOrUpdatedEntityModelSchema)

/**
 * @description Ошибка валидации | Жанр с указанным именем уже существует
 */
export const postApiTags400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const postApiTags401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const postApiTags403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const postApiTags500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const postApiTagsMutationRequestSchema = z.lazy(() => createOrUpdateTagModelSchema).describe("Тело запроса")

export const postApiTagsMutationResponseSchema = z.lazy(() => postApiTags200Schema)